module.exports = __webpack_public_path__ + "img/s15.a47f28a.png";